import { IRequestListValue } from 'common/schema/request/Request';
import { IWidget } from 'common/schema/widget/Widget';

/**
 * Controllo se posso aggiungere una nuova riga:
 * - se ho inserito almeno una riga, controllo se la riga è valorizzata
 *  - se la riga è valorizzata, posso inserirne una nuova
 *  - se la riga non è valorizzata o non completamente valorizzata, non posso inserirne una nuova
 */
export function handleShowButton(rows: IRequestListValue, widget: IWidget) {
  const fieldsCount = widget.input?.extra?.cascade?.fields.length;
  for (const row of rows) {
    const rowKeys = Object.keys(row.values);
    if (rowKeys.length !== fieldsCount) return false;
    if (rowKeys.some(key => !row.values[key])) return false;
  }
  return true;
}
